/* global $, currentLeaderboardYear, data, query_string */
import _ from 'underscore'
import Table from 'bam-node-savant-table/table'
import { guff, isGuffable } from 'bam-node-baseball-savant/utils/guff'

const png = require('save-svg-as-png')
const scatterPlot = require('bam-node-bdata-charts/chart.scatter').MakeChart
const beeSwarm = require('bam-node-bdata-charts/chart.beeswarm').MakeChart

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'sortable_stats'

const toolTipText = {
    avg_hyper_speed:
        'Adjusted EV averages the maximum of 88 and the actual exit velocity of each batted ball event.',
    avg_best_speed: `For a batter, EV50 is an average of the hardest 50% of his batted balls. For a pitcher it is the average of his softest 50% of batted balls allowed.`,
}

$(document).ready(function docReady() {
    $('.save').click(() => {
        png.saveSvgAsPng(document.getElementById('svg_scatter'), 'chart.png', {
            backgroundColor: '#ffffff',
        })
    })

    $('#ddlSeason').change(() => {
        $('#lblSeason').html($('#ddlSeason option:selected').text())
    })

    $('#ddlR2').change(() => {
        $('#lblR2').html($('#ddlR2 option:selected').text())
        populateUrl()
        createScatter()
    })

    $('#ddlSeason').click(() => {
        $('#seasonSelectors').toggle()
    })

    $('.year').click(() => {
        const years = getSelectedYears()
        if (years.length === 0) {
            $('#lblSeason').html('<span style="color: #b00">Select Year</span>')
        } else if (years.length === 1) {
            $('#lblSeason').html(`Year (${years[0]})`)
        } else {
            $('#lblSeason').html(
                `Year (${years[0]}+${years.length - 1})</span>`
            )
        }
    })

    $('#ddlColumns').click(() => {
        $('#columnSelectors').toggle()
    })

    $('#btnColumnClose').click(() => {
        $('#columnSelectors').hide()
    })

    $('#btnSeasonClose').click(() => {
        $('#seasonSelectors').hide()
    })

    $('#ddlType').change(() => {
        $('#lblType').html($('#ddlType option:selected').text())
        window.location.href = populateUrl()
    })

    $('#ddlChartType').change(() => {
        if ($('#ddlChartType').val() === 'beeswarm') {
            $('#yHolder, #rHolder').hide()
        } else {
            $('#yHolder, #rHolder').css('display', 'inline-block')
        }
        $('#lblChartType').html($('#ddlChartType option:selected').text())
        populateUrl()
        createScatter()
    })

    function updateMinLabel() {
        const rawVal = $('#ddlMin').val()
        const val = rawVal === 'q' ? 'Qualified' : rawVal

        $('#lblMin').html(`Minimum PA (${val})`)
    }

    $('#ddlMin').change(() => {
        updateMinLabel()
        populateUrl()
    })

    if (query_string.min) {
        $('#ddlMin').val(query_string.min).attr('selected', true)
    }
    updateMinLabel()

    if (query_string.year) {
        const years = query_string.year.split(',')
        for (let i = 0; i < years.length; i++) {
            $(`#year_${years[i]}`).prop('checked', true)
        }

        if (years.length === 1) {
            $('#lblSeason').html(`Year (${years[0]})`)
        } else {
            $('#lblSeason').html(
                `Year (${years[0]}+${years.length - 1})</span>`
            )
        }
    } else {
        $(`#year_${currentLeaderboardYear}`).prop('checked', true)
    }

    if (query_string.type) {
        $('#ddlType').val(query_string.type).attr('selected', true)
        $('#lblType').html($('#ddlType option:selected').text())
    }

    const oldParamMap = {
        b_total_pa: 'pa',
        p_total_pa: 'pa',
        b_ab: 'ab',
        p_ab: 'ab',
        p_total_hits: 'hit',
        b_total_hits: 'hit',
        p_single: 'single',
        b_single: 'single',
        p_double: 'double',
        b_double: 'double',
        p_triple: 'triple',
        b_triple: 'triple',
        p_home_run: 'home_run',
        b_home_run: 'home_run',
        p_strikeout: 'strikeout',
        b_strikeout: 'strikeout',
        p_walk: 'walk',
        b_walk: 'walk',
        p_k_percent: 'k_percent',
        b_k_percent: 'k_percent',
        p_bb_percent: 'bb_percent',
        b_bb_percent: 'bb_percent',
    }

    if (query_string.selections) {
        const ids = query_string.selections.split(',')
        for (let i = 0; i < ids.length; i++) {
            const key = oldParamMap[ids[i]] || ids[i]
            $(`#${key}`).prop('checked', true)

            $('#ddlX, #ddlY').append(
                $('<option></option>')
                    .attr('value', this.id)
                    .text($(`#lbl_${this.id}`).text())
            )
        }
    }

    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }
    if (query_string.chart === 'true') {
        $('#scatterContainer').show()
        $('#ddlX').val(query_string.x).attr('selected', true)
        $('#lblX').html(`${$('#ddlX option:selected').text()}&nbsp`)
        $('#ddlY').val(query_string.y).attr('selected', true)
        $('#lblY').html(`${$('#ddlY option:selected').text()}&nbsp`)

        $('#ddlChartType').val(query_string.chartType).attr('selected', true)
        $('#lblChartType').html($('#ddlChartType option:selected').text())

        if (query_string.chartType === 'beeswarm') {
            $('#yHolder').hide()
            $('#rHolder').hide()
        } else {
            $('#yHolder').css('display', 'inline-block')
            $('#rHolder').css('display', 'inline-block')
        }
    }

    const $defaultCheckbox = document.getElementById('chkDefault')
    const $defaultCols = document.querySelectorAll('.default-custom-column')

    function setDefaults(checked) {
        $defaultCols.forEach((el) => {
            // eslint-disable-next-line no-param-reassign
            el.checked = checked
        })
    }

    $defaultCheckbox.addEventListener('change', (e) => {
        setDefaults(e.target.checked)

        createTable()
    })

    $('#chkStatcast').click(() => {
        if ($('#chkStatcast').is(':checked')) {
            $('.statcast').prop('checked', true)
            createTable()
        } else {
            $('.statcast').prop('checked', false)
            createTable()
        }
    })

    $('#chkBasic').click(() => {
        if ($('#chkBasic').is(':checked')) {
            $('.basic').prop('checked', true)
            createTable()
        } else {
            $('.basic').prop('checked', false)
            createTable()
        }
    })

    $('#chkStatcast').click(() => {
        if ($('#chkStatcast').is(':checked')) {
            $('.statcast').prop('checked', true)
            createTable()
        } else {
            $('.statcast').prop('checked', false)
            createTable()
        }
    })

    $('form').submit(false)

    $('.column').click(() => {
        createTable()
    })

    if (data && data.length > 0) {
        createTable()
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    $('#btnChart').click(() => {
        $('#scatterContainer').toggle()

        populateUrl()
    })

    $('#btnUnselect').click(() => {
        $('#sort').val(1)
        $('.column, #chkStatcast, #chkBasic').prop('checked', false)
        $('#scatterContainer').hide()
        createTable()
    })

    $('#btnUpdate').click(() => {
        window.location.href = populateUrl()
    })
    $('#btnCSV').click(() => {
        window.location.href = `${populateUrl()}&csv=true`
    })

    if ($('.column:checkbox:checked').length === 0) {
        $defaultCheckbox.checked = true
        setDefaults(true)
        createTable()
    }
})

window.addEventListener('scroll', () => {
    if (!ticking && data.length) {
        window.requestAnimationFrame(() => {
            checkHeaderPosition(tableDivId)
            ticking = false
        })

        ticking = true
    }
})

function checkHeaderPosition(divId) {
    const scrollPosY = window.scrollY
    const posTop = $(`#${divId}`).offset().top
    const height = $(`#${divId} table thead`).height()
    if (!isFixedHeaderShowing && posTop < scrollPosY) {
        isFixedHeaderShowing = true
        addStaticHeader(divId)
    } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
        $(`#${divId} table thead`).removeClass('fixed-header')
        isFixedHeaderShowing = false
    }
}

function addStaticHeader(divId) {
    const width = $(`#${divId}`).outerWidth()
    // $(".tr-component-row th").removeClass("column-sort");

    if (width && width > 767) {
        let tableCell = 0

        // Set TH Width before applying fixed-header
        $('.default-table-row')
            .first()
            .children('td')
            .each(function handleEach() {
                const outerWidth = $(this).outerWidth()
                $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                    'width',
                    outerWidth
                )
                tableCell += 1
            })

        $(`#${divId} table thead`).addClass('fixed-header')
        tableCell = 0

        // Set TD Width before applying fixed-header
        $('.tr-component-row')
            .children('th')
            .each(function handleEach() {
                const outerWidth = $(this).outerWidth()
                $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                    'width',
                    outerWidth
                )
                tableCell += 1
            })
    }
}

window.addEventListener('resize', () => {
    if (isFixedHeaderShowing) {
        addStaticHeader(tableDivId)
    }
})

function populateUrl(sortColumn, sortDirection) {
    const year = getSelectedYears()
    const selections = [
        ...document.querySelectorAll('.column[type=checkbox]:checked'),
    ]
        .map((el) => el.id)
        .join(',')

    const parameters = {
        year: year.join(','),
        type: document.getElementById('ddlType').value,
        filter: document.getElementById('filter').value,
        min: document.getElementById('ddlMin').value,
        selections,
        chart: $('#scatterContainer').is(':visible') ? 'true' : 'false', // got lazy
        x: document.getElementById('ddlX').value,
        y: document.getElementById('ddlY').value,
        r: document.getElementById('ddlR2').value,
        chartType: document.getElementById('ddlChartType').value,
        sort: document.getElementById('sort').value,
        sortDir: document.getElementById('sortDir').value,
    }

    if (sortColumn) {
        parameters.sort = sortColumn
        document.getElementById('sort').value = sortColumn
    }

    if (sortDirection) {
        parameters.sortDir = sortDirection
        document.getElementById('sortDir').value = sortDirection
    }

    const urlParams = new URLSearchParams(parameters)

    const url = `${window.location.pathname}?${urlParams.toString()}`

    window.history.replaceState('', '', url)
    return url
}

function getSortField(headers) {
    if (!headers.length) {
        return null
    }

    const sortVal = document.getElementById('sort').value || 'xwoba'

    // previously, we sorted by column number
    const idx = Number(sortVal)

    if (!Number.isNaN(idx)) {
        return headers[idx]?.field || headers[0].field
    }

    const header = headers.find((d) => d.field === sortVal)

    return header ? sortVal : headers[0].field
}

function createTable() {
    const headers = [
        {
            name: 'Player',
            field: 'player_name',
            headerClass: 'th-component-header align-left table-static-column',
            fieldClass: 'tr-data align-left table-static-column',
            photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
            photoId: 'player_id',
            displayFn: (name, { player_id }) =>
                `<a href="/savant-player/${player_id}">${name}</a>`,
        },
        {
            name: 'Year',
            field: 'year',
            headerClass: 'th-component-header align-left',
            fieldClass: 'tr-data align-left',
            type: 'number',
        },
    ]

    $('#ddlX, #ddlY').find('option').remove().end()

    $('#lblColumns').html(
        `Custom Columns (${$('.column:checkbox:checked').length})`
    )
    const newColumns = []

    $('.column:checkbox:checked').each(function handleEach() {
        let name = $(`#lbl_${this.id}`).text()

        if (newColumns.includes(this.id)) {
            name = `
                    <div style="font-size: 0.9rem; line-height: 1;">
                        <div class="nav-badge">
                            New
                        </div>
                        <div>
                            ${name}
                        <div>
                    </div>`
        }

        const toolTip = toolTipText[this.id]

        headers.push({
            name,
            field: this.id,
            headerClass: 'th-component-header',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val) => {
                if (isGuffable(this.id)) {
                    return guff(val, this.id)
                }

                return val
            },
            toolTip,
        })

        $('#ddlX, #ddlY').append(
            $('<option></option>')
                .attr('value', this.id)
                .text($(`#lbl_${this.id}`).text())
        )
    })

    if (query_string.filter && query_string.filter !== 'undefined') {
        $('#filter').val(query_string.filter)
    }

    if (query_string.x || query_string.y) {
        $('#ddlX').val(query_string.x).attr('selected', true)
        $('#lblX').html(`${$('#ddlX option:selected').text()}&nbsp`)
        $('#ddlY').val(query_string.y).attr('selected', true)
        $('#lblY').html(`${$('#ddlY option:selected').text()}&nbsp`)
        $('#ddlR2').val(query_string.r).attr('selected', true)
        $('#lblR2').html($('#ddlR2 option:selected').text())
    }

    populateUrl()

    $('#lblX').html(`${$('#ddlX option:selected').text()}&nbsp`)
    $('#lblY').html(`${$('#ddlY option:selected').text()}&nbsp`)

    const width = $(`#${tableDivId}`).outerWidth()
    let repeatHeaders = false
    if (width <= 768) {
        repeatHeaders = 15
    }

    const sortField = getSortField(headers)

    // eslint-disable-next-line no-new
    new Table({
        id: 'sortable_stats',
        repeatHeader: repeatHeaders,
        headers,
        data,
        showRank: true,
        sortClass: 'column-sort',
        defaultSort: sortField,
        defaultSortDirection: $('#sortDir').val(),
        sortCallback(column, _id, { state }) {
            populateUrl(column, state)
        },
    })

    if ($('.column:checkbox:checked').length > 0) {
        createScatter()
    }
}

$('#ddlX').on('change', () => {
    $('#lblX').html(`${$('#ddlX option:selected').text()}&nbsp`)
    populateUrl()
    createScatter()
})
$('#ddlY').on('change', () => {
    $('#lblY').html(`${$('#ddlY option:selected').text()}&nbsp`)
    populateUrl()
    createScatter()
})

function getSelectedYears() {
    const years = []
    $('.year:checkbox:checked').each(function handleEach() {
        const year = this.id.split('_')[1]
        years.push(year)
    })

    return years
}

function getWidth(maxWidth) {
    let width = $('#sortable_stats').width()
    if (width > maxWidth || Number(width) === 0) {
        width = maxWidth
    }

    return width
}

$('#filter').keyup(() => {
    createScatter()
    populateUrl()
})

function createScatter() {
    let showRegression = false
    if ($('#ddlR2').val() === 'yes') {
        showRegression = true
    }

    const maxWidth = 870
    const width = getWidth(maxWidth)

    const opts = {
        width,
        data,
        id: 'scatter',
        chartType: $('#ddlX').val(),
        xVal: $('#ddlX').val(),
        yVal: $('#ddlY').val(),
        xTitle: $('#ddlX option:selected').text(),
        yTitle: $('#ddlY option:selected').text(),
        colorType: 'none',
        colorTitle: '',
        opacity: 0.5,
        filter: $('#filter').val(),
        showRegression,
    }

    if ($('#ddlChartType').val() === 'beeswarm') {
        beeSwarm(opts)
    } else {
        opts.data = _.filter(
            opts.data,
            (d) => d[opts.xVal] !== null && d[opts.yVal] !== null
        )

        scatterPlot(opts)
    }
}
